import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';
import { Row, Col, Image, Button } from 'react-bootstrap';
import { UserIcon, HomeIcon } from '@heroicons/react/24/solid';
import '../styles/roomCard.css'
import { useTranslation } from 'react-i18next';

const RoomCardHorizontal = ({ gemImage, title, description, capacity, bed, images, facilities, color, onClick, mode }) => {
  const { t } = useTranslation()

  const CarouselImages = () => {
    return (
      <Carousel className="carouselContainer" controls={false} indicators={false} style={{borderRadius: '14px', overflow: 'hidden'}}>
        {images?.map((image, index) => 
          <Carousel.Item key={index}>
            <Image src={image.src} style={{height: mode === 'single' ? '16.75rem' : '16rem', width: '100%', objectFit: 'cover'}} alt="RoomCardHorizontalCarouselImage"/>
          </Carousel.Item>
        )}
      </Carousel>
    )
  }

  return (
    <Row className="d-flex justify-content-center mt-4 cardRow">
      <Col xs={11} lg={mode === "single" ? 11 : 6}>
        <Card 
          className="md p-0 cardContainer" 
          style={{ "--color": `${color}`, cursor: 'pointer', borderRadius: '14px', marginRight: '1rem' }}
          onClick={onClick}
        >
          <Row className="d-flex justify-content-start">
            <Col xs={6} lg={5}>
              <CarouselImages/>
            </Col>

            <Col xs={6} lg={7}>
              <Card.Body className="cardContainerBody">

                <Card.Title className="d-flex flex-row">
                  <Image className="roomGemImage" src={gemImage} alt={title + "-gem-image"}/>
                  {mode === "single" ? <h4 style={{fontWeight: 'bold'}}>{title}</h4> : title}
                </Card.Title>

                <Row>
                  <Col className="col-auto">
                    <UserIcon style={{height: '1rem', color: '#595959', marginTop: '-0.1rem', marginRight: '0.25rem'}} alt="RoomCardHorizontalDetailsCardUserIcon"/>
                  </Col>
                  <Col className="col-auto" style={{marginRight: '.5rem'}}>
                    <Card.Text style={{color: '#595959', fontWeight: '400'}}>{capacity} Guests</Card.Text>
                  </Col>

                  <Col className="col-auto">
                    <HomeIcon style={{height: '1rem', color: '#595959', marginTop: '-0.2rem', marginRight: '0.25rem'}} alt="RoomCardHorizontalDetailsCardHomeIcon"/>
                  </Col>
                  <Col className="col-auto" style={{marginRight: '.5rem'}}>
                    <Card.Text style={{color: '#595959', fontWeight: '400',}}>{bed}</Card.Text>
                  </Col>
                </Row>

                <hr style={{width: '100%'}} />

                <Card.Text className="cardContainerDescription">{description}</Card.Text>

                {mode !== "single" && 
                  <Row className="d-flex justify-content-between" style={{marginTop: '1rem', marginBottom: '-1rem'}}>
                    <Col className="col-auto">
                      <Button className="bookNowButton" style={{padding: '.35rem 2rem', "--color": `${color}`}}>{t('details')}</Button>
                    </Col>

                  </Row>
                }
              </Card.Body>
            </Col>

            <div className="cardContainerImage"></div>
          </Row>
        </Card>
      </Col>
    
    {mode !== "single" && 
      <Col xs={11} lg={4} className="roomInfoCol">
        <Card 
          className="md p-0 roomsInfo" 
          style={{ "--color": `${color}`}}
          onClick={onClick}
        >
          <Card.Title className="roomInfoHeader" style={{backgroundColor: 'rgb(0,0,0,0.01)'}}>{title}</Card.Title>
          <Card.Body className="roomsInfoBody">
            {/* <p>{description}</p> */}
            <div className="roomInfoImage"></div>

            <div className="d-flex justify-content-center">
              <ul style={{maxHeight: '5rem'}}>
                {facilities.map((facility, index) => index % 2 === 0 &&
                  <li 
                    key={index} 
                    style={{color: '#595959', marginRight: '.5rem', marginTop: '.25rem'}}
                  >
                    <Card.Text style={{color: '#595959', fontWeight: '400'}}>{facility}</Card.Text>
                  </li>
                )}
              </ul>

              <ul style={{maxHeight: '5rem'}}>
                {facilities.map((facility, index) => index % 2 !== 0 &&
                  <li 
                    key={index} 
                    style={{color: '#595959', marginRight: '.5rem', marginTop: '.25rem'}}
                  >
                    <Card.Text style={{color: '#595959', fontWeight: '400'}}>{facility}</Card.Text>
                  </li>
                )}
              </ul>
            </div>
          </Card.Body>
        </Card>
      </Col>
    }
    </Row>
  )
}

export default RoomCardHorizontal